@if (currentClient) {
  <ngx-simplebar class="mx-n3 pt-4 px-4 file-manager-content-scroll">
    <div class="row">
      <div class="col-lg-12">
        <div class="card mt-n4 mx-n4">
          <div class="bg-info-subtle">
            <div class="card-body pb-0 px-4">
              <div class="row mb-3">
                <div class="col-md">
                  <div class="row align-items-center g-3">
                    <div class="col-md-auto d-lg-none">
                      <button type="button" class="btn btn-sm" id="sideabr-hamburger-icon" (click)="toggleSidebar(true)">
                        <span class="hamburger-icon">
                          <span></span>
                          <span></span>
                          <span></span>
                        </span>
                      </button>
                    </div>
                    @if (currentClient.logo) {
                      <div class="col-md-auto">
                        <div class="avatar-md">
                          <div class="avatar-title bg-white rounded-circle">
                            <img src="{{ currentClient.logo }}" alt="" class="avatar-xs">
                          </div>
                        </div>
                      </div>
                    }
                    <div class="col-md">
                      <div>
                        <h4 class="fw-bold">{{ currentClient.name }}</h4>
                        <div class="hstack gap-3 flex-wrap">
                          @if (currentClient.client_extra && currentClient.client_extra.client_type?.length > 0) {
                            <div>
                              <i class="ri-building-line align-bottom me-1"></i> @for (item of currentClient.client_extra.client_type; track item) {
                              <span>{{ item + ','}}</span>
                            }
                          </div>
                        }
                        @if (currentClient.client_extra && currentClient.client_extra.client_type?.length > 0) {
                          <div class="vr"></div>
                        }
                        <div><span class="fw-bold text-decoration-underline">Create Date</span>: <span class="fw-medium">{{ currentClient.createdAt | date: 'medium' }}</span></div>
                        <div class="vr"></div>
                        <div><span class="fw-bold text-decoration-underline">Update Date</span>: <span class="fw-medium">{{ currentClient.updatedAt | date: 'medium' }}</span></div>
                        <div class="vr"></div>
                        <div class="badge rounded-pill fs-8" [ngClass]="currentClient.status === 'ACTIVE' ? 'bg-success' : currentClient.status === 'PENDING' ? 'bg-warning' : 'bg-danger'">{{ currentClient.status }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-auto">
                <div class="hstack gap-1 flex-wrap">
                  @if (currentClient.status !== 'ACTIVE') {
                    <button type="button" (click)="openConfirmUpdateClientStatus('ACTIVE')" class="btn p-0 fs-24 text-success shadow-none" ngbTooltip="Activate Client" placement="bottom" alt="Activate Client"><i class="ri-checkbox-circle-fill"></i></button>
                  }
                  @if (currentClient.status !== 'SUSPENDED') {
                    <button type="button" (click)="openConfirmUpdateClientStatus('SUSPENDED')" class="btn p-0 fs-24 text-danger shadow-none" ngbTooltip="Suspend Client" placement="bottom" alt="Suspend Client"><i class="ri-indeterminate-circle-fill"></i></button>
                  }
                </div>
              </div>
            </div>
            <ul ngbNav #clientNav="ngbNav" [activeId]="currenttab" class="nav nav-tabs-custom border-bottom-0" role="tablist">
              <li [ngbNavItem]="1" class="nav-item">
                <a ngbNavLink role="none" (click)="changeTab('details')">Details</a>
                <ng-template ngbNavContent>
                  <div class="text-center">
                    <h1 class="text-warning">COMING SOON</h1>
                    <p class="text-muted">We need to decide on a design for this page first, and what to show on it.</p>
                  </div>
                </ng-template>
              </li>
              <li [ngbNavItem]="2" class="nav-item">
                <a ngbNavLink role="none" (click)="changeTab('plans')">Plans</a>
                <ng-template ngbNavContent>
                  <app-client-plans [currentClient]="currentClient"></app-client-plans>
                </ng-template>
              </li>
              <li [ngbNavItem]="3" class="nav-item">
                <a ngbNavLink role="none" (click)="changeTab('users')">Users</a>
                <ng-template ngbNavContent>
                  <app-client-users [currentClient]="currentClient"></app-client-users>
                </ng-template>
              </li>
              <li [ngbNavItem]="4" class="nav-item">
                <a ngbNavLink role="none" (click)="changeTab('activities')">Activities</a>
                <ng-template ngbNavContent>
                  <app-client-activities [currentClient]="currentClient"></app-client-activities>
                </ng-template>
              </li>
              <li [ngbNavItem]="5" class="nav-item">
                <a ngbNavLink role="none" (click)="changeTab('templates')">Report Templates</a>
                <ng-template ngbNavContent>
                  <div class="list-group mb-3">
                    @for (item of report_templates; track item) {
                      <label class="list-group-item">
                        <input class="form-check-input me-1" type="checkbox" [value]="item.value" [checked]="isSelected(item.value)" (change)="toggleTemplateSelection($event, item)"> {{ item.name }}
                      </label>
                    }
                  </div>
                  <button type="button" class="btn btn-success waves-effect waves-light" (click)="updateClientTemplates()">
                    <span class="d-flex justify-content-center">
                      @if (submitted && spinner) {
                        <span class="spinner-border" role="status">
                          <span class="visually-hidden">Loading...</span>
                        </span>
                      }
                      <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Update Templates</span>
                    </span>
                  </button>
                </ng-template>
              </li>
              <li [ngbNavItem]="6" class="nav-item">
                <a ngbNavLink role="none" (click)="changeTab('bucketCustomDomain')">Bucket Custom Domain</a>
                <ng-template ngbNavContent>
                  <div class="list-group mb-3">
                    <label class="list-group-item">
                      <input class="form-check-input me-1" type="checkbox" [value]="currentClient.bucket_custom_domain" [checked]="currentClient.bucket_custom_domain" (change)="updateClientBucketCustomDomain()"> {{ currentClient.bucketName + '-api-storage.revealense.com' }}
                    </label>
                  </div>
                </ng-template>
              </li>
            </ul>
          </div>
          <!-- end card body -->
        </div>
      </div>
      <!-- end card -->
    </div>
    <!-- end col -->
  </div>
  <div class="row">
    <div class="col-lg-12">
      <div class="tab-content text-muted">
        <div [ngbNavOutlet]="clientNav"></div>
      </div>
    </div>
  </div>
</ngx-simplebar>
}

<ng-template #updateClientStatusModal let-modal>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
    </div>
    <div class="modal-body">
      <div class="mt-2 text-center">
        @if (selectedStatus === 'ACTIVE') {
          <lord-icon src="https://cdn.lordicon.com/dangivhk.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
        }
        @if (selectedStatus !== 'ACTIVE') {
          <lord-icon src="https://cdn.lordicon.com/xjvrxoon.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
        }
        <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
          <h4>Are you Sure You want to {{ selectedStatus === 'ACTIVE' ? 'activate' : 'suspend' }}
            <span class="fw-semibold fw-24 text-warning">{{ currentClient.name }}</span>?
          </h4>
        </div>
      </div>
      <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
        <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
        <button type="button" class="btn w-sm btn-load" [ngClass]="selectedStatus === 'ACTIVE' ? 'btn-success' : 'btn-danger'" (click)="updateClientStatus()">
          <span class="d-flex justify-content-center">
            @if (submitted && spinner) {
              <span class="spinner-border" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            }
            <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, I am sure!</span>
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #successModal let-modal>
  <div class="modal-content">
    <div class="modal-body text-center p-5">
      <div class="text-end">
        <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
      </div>
      <div class="mt-2">
        @if (success) {
          <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
        }
        @if (!success) {
          <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
        }
        <h4 class="mb-3 mt-4">{{ successMessage }}</h4>
        @if (!success) {
          <p class="text-muted mx-4 mb-0">{{ message }}</p>
        }
      </div>
    </div>
  </div>
</ng-template>